export default "__VITE_ASSET__D_eB4VAa__"